import { render } from "./SimpleDialog.vue?vue&type=template&id=b0e894ea"
import script from "./SimpleDialog.vue?vue&type=script&lang=js"
export * from "./SimpleDialog.vue?vue&type=script&lang=js"

import "./SimpleDialog.vue?vue&type=style&index=0&id=b0e894ea&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__